import packageJson from '../../package.json';

export const environment = {
  production: false,
  API_URL_ANZ: 'https://api.staging.setconnect.io/api/',
  API_URL_UK: 'https://api.staging.setconnect.io/api/',
  ENV_AS_TEXT: 'SetConnect-VK-Staging',
  APP_NAME: 'SetConnect Visitor Kiosk - Staging',
  AES_STORAGE_KEY: '!w5ZS*0=J\'e6px]o/lUXO_^ku#9EfF',
  SENTRY_DSN: 'https://06964f1b8a237b6d88a623252fa032b9@o4509041843699712.ingest.us.sentry.io/4509150049206272',
  SENTRY_ENVIRONMENT: 'staging',
  SENTRY_RELEASE: 'setconnect-kiosk@'+packageJson.version,
  SENTRY_TRACES_SAMPLE_RATE: 0.1,
  SENTRY_REPLAYS_SESSION_SAMPLE_RATE: 0.1,
  SENTRY_NATIVE_REPLAYS_SESSION_SAMPLE_RATE: 0.0,
  SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE: 0.1,
  IPAPI_TOKEN: '53925c3b520983'
};
